<template>
  <div :class="'col-md' + col">
    <div class="pagination_content">
      <button class="preview_next" @click="previousPage" :disabled="currentPage === 1">
        <ion-icon name="chevron-back-outline"></ion-icon>
      </button>
      <ul class="page_list">
        <li
          class="list"
          v-for="(page, index) in visiblePages"
          :key="index"
          @click="goToPage(page)"
          :class="{ active: page === currentPage, 'pointer-events-none': page === '...' }">
          {{ page }}
        </li>
      </ul>
      <button class="preview_next" @click="nextPage" :disabled="currentPage === totalPages">
        <ion-icon name="chevron-forward-outline"></ion-icon>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "pagination",
  props: {
    totalItems: {
      required: true
    },
    itemsPerPage: {
      default: 20
    },
    col: {
      default: 12
    },
    currentPage: {
      default: 1
    }
  },
  computed: {
    totalPages() {
      const total = this.totalItems / this.itemsPerPage;
      return total !== Infinity ? Math.ceil(total) : 0;
    },
    visiblePages() {
      const totalPages = this.totalPages;
      let startPage = Math.max(1, this.currentPage - 3);
      let endPage = Math.min(totalPages, this.currentPage + 3);
      const pages = []

      if(totalPages === 1){
        pages.push(1)
      } else {

        if (startPage > 1) {
          pages.push(1)
        }
        if (startPage > 2) {
          pages.push(2)
        }
        if (startPage > 3) {
          pages.push(3)
        }
        if (startPage > 4) {
          pages.push('...')
        }

        for (let page = startPage; page <= endPage; page++) {
          pages.push(page);
        }

        if (endPage < totalPages - 4) {
          pages.push('...');
        }

        if (endPage < totalPages - 3) {
          pages.push(totalPages - 2);
        }
        if (endPage < totalPages - 2) {
          pages.push(totalPages - 1)
        }
        if (endPage < totalPages - 1) {
          pages.push(totalPages)
        }
      }
      return pages
    }
  },
  methods: {
    previousPage() {
      if(this.currentPage > 1)
        this.$emit('update:currentPage', this.currentPage - 1);
    },
    nextPage() {
      if(this.currentPage < this.totalPages)
        this.$emit('update:currentPage', this.currentPage + 1);
    },
    goToPage(page) {
      this.$emit('update:currentPage', page);
    },
  },
};
</script>

<style lang="scss" scoped>

.pointer-events-none {
  pointer-events: none;
}

.pagination_content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.page_list {
  display: flex;
  gap: 15px;
  margin-top: auto;
  margin-bottom: auto;
  background: #ffffff;
  padding: 4px 16px;
  border-radius: 20px !important;
}
.list {
  list-style: none;
  width: 24px;
  height: 24px;
  font-weight: bold;
  text-align: center;
  padding-top: 2px;
  cursor: pointer;

  &:hover {
    color: #1B59F8;
  }
}

.active {
  background: #1B59F8;
  color: #fff;
  border-radius: 5px !important;

  &:hover {
    color: #ffffff;
  }
}

.preview_next {
  display: flex;
  padding: 8px;
  border-radius: 50% !important;
  border: none;
  background: #ffffff;

  &:hover {
    background: #1B59F8;
    color: #fff;
  }

  &:active {
    background: #1B59F8;
  }
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/tools/pagination.vue